/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
const gridEditRowStyle = {
  icon: {
    padding: "0 0 8px 0",
    cursor: "pointer",
    minWidth: 36,
  },
};

export default gridEditRowStyle;
